import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Bank,
  Brush,
  Buildings,
  Convert,
  Receipt1,
  Routing,
  Setting3,
} from 'iconsax-react';

import { Tabs, TabsList, TabsTrigger } from '@design-system/tabs';

import { createRoute, PATHS } from '@src/core/router/paths';
import { entities } from '@shared/constants/entities';
import { useHasPermission } from '@shared/hooks/use-has-permission';

export const SettingsTabs = () => {
  const { pathname } = useLocation();
  const hasPermission = useHasPermission();

  const TABS = [
    // {
    //   title: 'Profile Settings',
    //   path: createRoute(PATHS.SETTINGS_PROFILE_SETTINGS),
    // },
    {
      title: 'Organization Info',
      path: createRoute(PATHS.SETTINGS_COMPANY_INFO),
      icon: <Buildings size='18' />,
      isAllowed: hasPermission(entities.organization, 'view'),
    },
    {
      title: 'Billing & Subscription',
      path: createRoute(PATHS.SETTINGS_BILLING_A_SUBSCRIPTION),
      icon: <Receipt1 size='18' />,
      isAllowed: hasPermission(entities.organizationsubscription, 'view'),
    },
    {
      title: 'Integration',
      path: createRoute(PATHS.SETTINGS_INTEGRATION),
      icon: <Convert size='18' />,
      isAllowed: hasPermission(entities.integration, 'view'),
    },
    {
      title: 'Organizations',
      path: createRoute(PATHS.SETTINGS_BRANCHES),
      icon: <Routing size='18' />,
      isAllowed: hasPermission(entities.organization, 'view'),
    },
    {
      title: 'Preferences',
      path: createRoute(PATHS.SETTINGS_PREFERENCES),
      icon: <Setting3 size='18' />,
      isAllowed: hasPermission(entities.organization, 'view'),
    },
    {
      title: 'Brand Theme',
      path: createRoute(PATHS.SETTINGS_BRAND_THEME),
      icon: <Brush size='18' />,
      isAllowed: hasPermission(entities.organization, 'view'),
    },
    {
      title: 'Bank Info',
      path: createRoute(PATHS.SETTINGS_BANK_INFO),
      icon: <Bank size='18' />,
      isAllowed: hasPermission(
        [entities.bankAccount, entities.eWalletAccount],
        'view'
      ),
    },
  ].filter((tab) => tab.isAllowed !== false);

  return (
    <Tabs className='w-full pt-4 shadow-sm border-b-0 shadow-gray-300'>
      <TabsList>
        {TABS.map((tab) => {
          const active = new Map([[tab.path === pathname, 'active']]);

          return (
            <TabsTrigger
              key={tab.title}
              data-state={active.get(true)}
              value={tab.title}
              asChild
              className='mx-5'
            >
              <Link
                className='flex gap-2'
                to={tab.path}
              >
                {React.cloneElement(tab.icon, {
                  variant: active.get(true) ? 'Bold' : '',
                })}
                {tab.title}
              </Link>
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
};
